export default __webpack_public_path__ + "static/media/image2.8dda4669.png";